import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import { IScenarioPayload } from "../../interface/IScenarioPayload";
import { IFilterPayload } from "../../interface/IFilterPayload";

// Define the payload for the GetDropdownDependentValues API
export interface IDependentValuesPayload {
  WeekNumber: number; 
  ErpItemId: string; 
  branchId: string; 
  PageNumber: string; 
  PriceMultiplier: number; 
  viewBy: string; 
}

// Define the payload for the Update Scenario Data API
export interface IUpdateScenarioPayload {
  data: {
    AdjustedForecast: number;
    AdjustedSOQ: number;
    BranchId: string;
    ErpItemId: string;
    Initial_AdjustedSOQ: number;
    PageNumber: string;
    PriceMultiplier: number;
    ScenarioPrice: number;
    ScenarioSelection: number;
    UserForecast: number;
    UserSOQSelection: number;
    UserSelection: number;
    aFlag: number;
    forecast_date: string;
    isPoundSelected: boolean;
    pFlag: number;
    replicate_date: string;
  }[];
}

export const consensusApi = createApi({
  reducerPath: "consensusApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    // Mutation: Get Scenario Data
    getSenarioData: builder.mutation({
      query: (payload: IScenarioPayload) => ({
        url: "/getSenarioData",
        method: "POST",
        data: payload,
      }),
    }),

    // Mutation: Get Filters for Consensus
    getConsensusFilter: builder.mutation({
      query: (payload: IFilterPayload) => ({
        url: "/getConsensusFilter",
        method: "POST",
        data: payload,
      }),
    }),

    // Mutation: Get Dropdown Dependent Values
    getDropDownDependentValues: builder.mutation({
      query: (payload: IDependentValuesPayload) => ({
        url: "/getDropDownDependentValues",
        method: "POST",
        data: payload,
      }),
    }),

    // Mutation: Update Scenario Data
    updateScenarioData: builder.mutation({
        query: (payload: IUpdateScenarioPayload) => ({
          url: '/updateScenarioData',
          method: 'PUT',
          data: payload,
        }),
      }),      
    // Mutation: Get SOQ Data
    getUpdateSoq: builder.mutation({
        query: () => ({
          url: '/updateSoq',
          method: 'GET',
        }),
      }),
  
      // Mutation: Export Scenario Data
      exportScenarioData: builder.mutation({
        query: () => ({
          url: '/exportScenarioData',
          method: 'GET',
        }),
      }),
    }),
  });
  
  // Export the hooks
  export const {
    useGetSenarioDataMutation,
    useGetConsensusFilterMutation,
    useGetDropDownDependentValuesMutation,
    useUpdateScenarioDataMutation,
    useGetUpdateSoqMutation,
    useExportScenarioDataMutation,
  } = consensusApi;